import React, { useState, useEffect } from "react";

import "./articles-section-styles.scss";

import getData from "./data-fetching";

// importing icons
import { MdOutlineArticle } from "react-icons/md";
import { FiArrowUpRight } from "react-icons/fi";

// importing components
import ButtonComponent from "../../components/button-component/button-component";
import SectionSubHeadingComponent from "../../components/section-sub-heading-component/section-sub-heading-component";
import SectionHeadingComponent from "../../components/section-heading-component/section-heading-component";

const ArticlesSection = () => {
	const [articles, setArticles] = useState([]);

	useEffect(() => {
		getData().then((data) => {
			setArticles(data.data.user.publication.posts);
		});
	}, []);

	return (
		<section id="articles-section" className="articles-section">
			<div className="articles-section-content-wrapper">
				<SectionSubHeadingComponent
					icon={<MdOutlineArticle />}
					text="Articles"
				/>
				<SectionHeadingComponent text="Stay Ahead: Latest Articles on Trends" />
				<div className="articles-container"></div>

				<div className="articles-content-wrapper">
					{articles.map((article) => {
						return (
							<a
								href={`https://moazamdev.hashnode.dev/${article.slug}`}
								className="article-link-card"
								target="_blank"
							>
								<div className="article-card">
									<div className="article-card-image-wrapper">
										<img
											src={article.coverImage}
											alt={article.title}
											className="article-card-image"
										/>
									</div>
									<div className="article-card-content-wrapper">
										<h4 className="pubDate">
											{article.dateAdded.slice(0, 10)}
										</h4>
										<h3 className="article-card-title">
											{article.title}
										</h3>
										<p className="article-card-brief">
											{article.brief}
										</p>
									</div>
								</div>
							</a>
						);
					}).filter((article, index) => index < 3)}
				</div>

				<ButtonComponent
					text="View All Articles"
					icon={<FiArrowUpRight />}
					type="large"
					btnLink="https://moazamdev.hashnode.dev/"
				/>
			</div>
		</section>
	);
};

export default ArticlesSection;
